import React, { useState } from "react";
import { X } from "lucide-react";
import { gallery } from "../mock";

const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="gallery" className="py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-end justify-between gap-6 flex-wrap reveal">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-emerald-300/80">
              Portfolio
            </div>
            <h2 className="mt-2 text-3xl md:text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
              Εργασίες από το <span className="text-emerald-400">εργαστήριό</span> μας
            </h2>
          </div>
          <p className="max-w-md text-emerald-50/70">
            Πραγματικές επισκευές από το εργαστήριο του Repairzone Π.Κ.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {gallery.map((item, i) => (
            <button
              key={i}
              onClick={() => setActive(item)}
              className={`relative overflow-hidden rounded-xl border border-emerald-900/60 group reveal text-left ${
                i === 0 ? "md:col-span-2 md:row-span-2" : ""
              }`}
            >
              <img
                src={item.src}
                alt={`${item.title} – ${item.desc} | Repairzone Λαμία`}
                className={`w-full ${
                  i === 0 ? "h-full min-h-[400px]" : "h-56 md:h-64"
                } object-cover img-hover`}
                loading="lazy"
                decoding="async"
                width="800"
                height="600"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#04101ce6] via-transparent to-transparent" />
              <div className="absolute bottom-3 left-3 right-3">
                <div className="text-white font-semibold text-sm">
                  {item.title}
                </div>
                <div className="text-emerald-300 text-xs">{item.desc}</div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          onClick={() => setActive(null)}
          className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4 cursor-zoom-out"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-5 right-5 w-10 h-10 rounded-md bg-black/60 border border-emerald-500/40 text-emerald-200 inline-flex items-center justify-center hover:border-emerald-400 transition-colors"
            aria-label="close"
          >
            <X className="w-5 h-5" />
          </button>
          <div
            onClick={(e) => e.stopPropagation()}
            className="max-w-5xl w-full"
          >
            <img
              src={active.src}
              alt={`${active.title} – ${active.desc} | Repairzone Λαμία`}
              className="w-full max-h-[80vh] object-contain rounded-lg border border-emerald-900/60"
            />
            <div className="mt-3 text-center">
              <div className="text-white font-semibold">{active.title}</div>
              <div className="text-emerald-300 text-sm">{active.desc}</div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
